import React from 'react'
import classNames from 'classnames'
import { Button } from '@winnin/winnin_ui.components.button'
import { Title } from '@winnin/winnin_ui.components.title'

import Modal from 'components/Modal'
import { SMALL_MODAL } from 'consts/modalStyles'
import { T } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'
import './index.scss'

const TOLGEE_PREFIX = 'GenericModal'

interface IGenericModal {
  closeModal: () => void
  error?: boolean
  onClick: () => void
  isOpen: boolean
  loading?: boolean
  mainText: string
  subtitle?: string
  buttonText?: string
  className?: string
  hideCancel?: boolean
}

export default function GenericModal({
  closeModal,
  error,
  onClick,
  isOpen,
  loading,
  mainText,
  subtitle,
  buttonText,
  className,
  hideCancel,
}: IGenericModal) {
  return (
    <Modal isOpen={isOpen} styleModal={SMALL_MODAL} onRequestClose={closeModal}>
      <div className={classNames('GenericModal', className)}>
        <Title tag="h3">{mainText}</Title>

        {subtitle && <h5 className="subtitle">{subtitle}</h5>}

        {error && (
          <p className="GenericModal-error">
            <T keyName={`${TOLGEE_PREFIX}-error`}>An error has occurred.</T>
          </p>
        )}

        <div className="modal-actions">
          {!hideCancel && (
            <Button onClick={closeModal} appearance="link" variation="faded">
              <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
            </Button>
          )}
          <Button onClick={onClick} disabled={Boolean(loading)}>
            {buttonText ? buttonText : <T keyName={TOLGEE_GLOBALS.delete.key}>{TOLGEE_GLOBALS.delete.defaultValue}</T>}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
